module.exports = __webpack_public_path__ + "static/media/NovotelSipcot01.945d3f35.jpg";